import { useCallback } from 'react';
import { useSafeState } from '..';
var stateChanger = function (state) { return state + (1 % Number.MAX_SAFE_INTEGER); };
/**
 * Return callback function that re-renders component.
 */
export function useRerender() {
    var _a = useSafeState(0), setState = _a[1];
    return useCallback(function () {
        setState(stateChanger);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
